import { render, staticRenderFns } from "./ChannelBanlist.vue?vue&type=template&id=09c4e4e0&"
import script from "./ChannelBanlist.vue?vue&type=script&lang=js&"
export * from "./ChannelBanlist.vue?vue&type=script&lang=js&"
import style0 from "./ChannelBanlist.vue?vue&type=style&index=0&id=09c4e4e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports